import './index.scss'
import React from 'react'
import { Row, Col } from '../../../components/layout'
import Content from '../../../components/content'
import Editable from "../../../components/editable/index";

// 我们的团队
const Features = (props) => {
  return [{
    uid: 'features-1',
    html:(
      <div className="section-features">
        <div className="container">
          <div className="section-info-wrap">
            {!props.title.is_hidden && <Content {...props.title} className="section-title text-center" />}
            {!props.paragraph.is_hidden && <div className="section-desc-wrap">{props.paragraph.content}</div>}
          </div>

          {
            !props.list.is_hidden &&
            <Row className="section-list-items">
              {props.list.items.map((item, index) =>
                <Col key={index}
                     className={"section-list-item col-xs-6 col-sm-3"}
                     name={ item.title.content }>
                  <div className="thumbnail">
                    <Content {...item.media} className="media-object"/>
                    <div className="caption">
                      <Editable {...item.title}>
                        <h4 className="caption-title">{item.title.content}</h4>
                      </Editable>
                      <Content { ...item.description } className="list-item-desc" />
                    </div>
                  </div>
                </Col>
              )}
            </Row>
          }
        </div>
      </div>
    )
  }, {
    uid: 'features-2',
    html:(
      <div className="section-features">
        <div className="container">
          {!props.title.is_hidden && <h2 className="section-title">{props.title.content}</h2>}
          {!props.paragraph.is_hidden && <div className="section-description">{props.paragraph.content}</div>}
          {
            !props.button.is_hidden &&
            <div className="section-features-button-wrap">
              <a className="btn btn-lg btn-primary" href={props.button.url}>{props.button.title}</a>
            </div>
          }
          {!props.media.is_hidden && <img style={{ maxHeight: '100%', maxWidth: '100%' }} src={props.media.src} />}
        </div>
      </div>
    )
  }, {
    uid: 'features-3',
    name: '左右图文(图右)',
    html:(
      <div className="section-features section-lr-graphic">
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <div className="section-features-description">
                {!props.title.is_hidden && <h2 className="section-title text-left">{props.title.content}</h2>}
                {!props.paragraph.is_hidden && <div className="section-description">{props.paragraph.content}</div>}
                {!props.button.is_hidden && <div className="section-button"><a href={props.button.url} className="btn btn-primary">{props.button.title}</a></div>}
              </div>
            </div>
            <div className="col-sm-6"> </div>
          </div>
        </div>
        {
          !props.media.is_hidden &&
          <div className="section-media"
               style={{width: '50%', backgroundImage: `url(${props.media.src}?)`}}>
          </div>
        }
      </div>
    )
  }, {
    uid: 'features-5',
    name: '左右图文(图左)',
    html:(
      <div className="section-features section-ll-graphic">
        <div className="container">
          <div className="row">
            <div className="col-sm-6"> </div>
            
            <div className="col-sm-6">
              <div className="section-features-description">
                {!props.title.is_hidden && <h2 className="section-title text-left">{props.title.content}</h2>}
                {!props.paragraph.is_hidden && <div className="section-description">{props.paragraph.content}</div>}
                {!props.button.is_hidden && <div className="section-button"><a href={props.button.url} className="btn btn-primary">{props.button.title}</a></div>}
              </div>
            </div>
          </div>
        </div>
        {
          !props.media.is_hidden &&
          <div className="section-media"
               style={{width: '50%', backgroundImage: `url(${props.media.src}?)`}}>
          </div>
        }
      </div>
    )
  }, {
    uid: 'features-4',
    name: '常见问题',
    html:(
      <div className="section-features section-features-faq">
        <div className="container">
          {!props.title.is_hidden && <h2 className="section-title">{props.title.content}</h2>}
          {!props.paragraph.is_hidden &&<div className="section-features-description">{props.paragraph.content}</div>}
          {
            !props.button.is_hidden &&
            <div className="section-features-button-wrap">
              <a className="btn btn-lg btn-primary" href={props.button.url}>{props.button.title}</a>
            </div>
          }
          <div className="row section-features-faq-list">
            {props.list.items.map((item, index) =>
              <div className="col-sm-6" key={'section-faq-'+ index}>
                <div className="section-faq-item">
                  <label className="faq-question">{item.title.content}</label>
                  <div className="faq-answer">{item.description.content}</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }]
}

export default Features


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/features/index.js